import { Props, Item } from '../List.types';

export const mapCalculationToItem = (calculation: Props['calculations'][0]): Item => {
  return {
    label: [calculation.calculationName, calculation.relatedCaseNumber, calculation.identifier]
      .filter((_) => _)
      .join(', '),
    calculationId: calculation.identifier,
  };
};
